import { SelectDescType } from '@/components/SelectWithDescriptions/SelectWithDescriptions';
import { EmployerOption } from '@/hooks/webapi/foxentry/FoxentryApiTypes';
import { EmploymentStatus } from '@/hooks/webapi/types/EmploymentStatus';

export const areEmployerDetailsRequired = (
  employmentTypeStatus?: EmploymentStatus,
): boolean =>
  ['EMPLOYEE', 'SELF_EMPLOYED'].includes(employmentTypeStatus || '');

export const getEmployerName = (
  value: string | EmployerOption | undefined,
): string => {
  return typeof value === 'string' ? value : value?.name ?? '';
};

export const parseEmploymentDetails = (
  employmentTypeStatus?: EmploymentStatus,
  profession?: SelectDescType,
) =>
  areEmployerDetailsRequired(employmentTypeStatus)
    ? profession?.value
    : undefined;
